module.exports = __webpack_public_path__ + "static/media/BoardDetail_test2.e153effe.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Reservation/assets/BoardDetail_test2.jpeg
// module id = 568
// module chunks = 0